import React from 'react';
import millennials from '../images/infographic1/A-millennials.png';
import boomers from '../images/infographic1/mobile/boomers.png';
import genx from '../images/infographic1/A-GenX.png';

// import homeowners from '../images/infographic1/B-Homeowners.png';
import raise from '../images/infographic1/mobile/raise.png';
import employment from '../images/infographic1/mobile/employment.png';
// import plate from '../images/infographic1/D-plate.png';
// import children from '../images/infographic1/E-children.png';
// import world from '../images/infographic1/F-world.png';
import mobileHeader from '../images/infographic1/mobile-header.png';
import homeowners from '../images/infographic1/mobile/B-homeowners.png';
import mobileapp from '../images/infographic1/mobile/B-mobileapp.png';
import rent from '../images/infographic1/mobile/B-rent.png';
import suburbs from '../images/infographic1/mobile/B-suburbs.png';
import stat from '../images/infographic1/mobile/B-stat.png';
import spend from '../images/infographic1/mobile/spend.png';
import save from '../images/infographic1/mobile/save.png';
import happy from '../images/infographic1/mobile/happy.png';
import sources from '../images/infographic1/mobile/sources.svg';
import icon from '../images/infographic1/mobile/info.png';
import popup1 from '../images/infographic1/popup1.png';
import popup2 from '../images/infographic1/popup2.png';
import popup3 from '../images/infographic1/popup3.png';
import popup4 from '../images/infographic1/popup4.png';

import Button from './Button';
import Tooltip from './Tooltip';

import CustomCarousel from 'react-custom-carousel';

import '../stylesheets/InfographicMobile.scss';

export default function InfographicMobile() {
  return (
    <div className="container mobile">
      <section className="mobile-intro">
        <img src={mobileHeader} alt="header" />
        <h1>
          Generations <br />
          of Wealth
        </h1>
        <h2>
          How <span className="blue">Millennials</span>, <span className="pink">Gen X</span>, and <span className="yellow">Baby Boomers</span> spend, save and think
          about&nbsp;wealth
        </h2>
      </section>
      <section className="mobile-content">
        <div className="mobile-section" id="A">
          <h3>Who are they?</h3>
          <p>
            Over the past decade America has witnessed a massive generational shift. The Baby Boomer generation has approached its golden years. Generation X has transformed the
            economy by taking tech beyond the personal computer. And Millennials have entered the economy and become a true force in society with great buying power.{' '}
            <span className="blue">
              While their parents may have defined wealth around security and stability—the house, the car, the nest egg—today’s young people are more likely to place value on
              things like flexibility, freedom, and fulfilment.
            </span>
          </p>
        </div>
        <div className="mobile-image">
          <Tooltip
            position={'top'}
            y={'10%'}
            x={'30%'}
            popup={popup1}
            popupId={'popup1'}
            link={
              'https://ad.doubleclick.net/ddm/trackclk/N781268.8535CNNNETWORK/B23177801.261209246;dc_trk_aid=457310378;dc_trk_cid=121227925;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua='
            }
          >
            <img src={icon} alt="infographic statistic" />
          </Tooltip>

          <CustomCarousel
            width={239}
            height={509}
            assets={[millennials, genx, boomers]}
            duration={5000}
            controls={false}
            dots={true}
            slidesClass={'carousel-slides1'}
            dotsClass={'dot1'}
          />
        </div>
        <div className="mobile-section" id="B">
          <h3>Where do they call home?</h3>
          <p>
            Because <span className="yellow">Boomers often view wealth in terms of stability</span>, they tended to buy their first homes at a younger age than Gen X or
            Millennials. As Millennials grow older and richer, more of them are leaving cities and buying homes, which they find via mobile apps.
          </p>
        </div>
        <div className="mobile-image second">
          <Tooltip
            position={'top'}
            y={'10%'}
            x={'30%'}
            popup={popup2}
            popupId={'popup2'}
            link={
              'https://ad.doubleclick.net/ddm/trackclk/N781268.8535CNNNETWORK/B23177801.261209249;dc_trk_aid=457308465;dc_trk_cid=121227925;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua='
            }
          >
            <img src={icon} alt="infographic statistic" />
          </Tooltip>
          <CustomCarousel
            width={261}
            height={152}
            assets={[homeowners, rent, mobileapp, suburbs]}
            duration={5000}
            controls={false}
            dots={true}
            slidesClass={'carousel-slides2'}
            dotsClass={'dot2'}
          />
        </div>
        <div className="mobile-image">
          <img src={stat} alt="stat" />
        </div>
        <div className="mobile-section" id="C">
          <h3>How Do they Earn Money?</h3>
          <p>
            Boomers grew up in a world of company men and could reliably expect to stay with one employer for a decade or two, if not for their entire careers. Gen X saw that
            confidence erode and invented the gig economy. <span className="blue">Millennials often equate wealth with flexibility</span>, and can expect or even hope to work for
            several employers over the course of multiple careers.
          </p>
        </div>
        <div className="mobile-image">
          <img src={raise} alt="millennials" />
        </div>
        <div className="mobile-image">
          <img src={employment} alt="millennials" />
        </div>
        <div className="mobile-section" id="D">
          <h3>How do they spend their time and money?</h3>
          <p>
            Today, because they are in middle age, <span className="pink"> Gen X has risen to the top of the pyramid in terms of material wealth</span>. But Millennials are
            changing the way money is spent. Increasingly they carry very little cash and use digital wallets like PayPal and Venmo for more and more of their expenditures.
          </p>
        </div>
        <div className="mobile-image" id="mobile-image-spend">
          <Tooltip
            position={'top'}
            y={'10%'}
            x={'30%'}
            popup={popup3}
            popupId={'popup3'}
            link={
              'https://ad.doubleclick.net/ddm/trackclk/N781268.8535CNNNETWORK/B23177801.261209252;dc_trk_aid=457309253;dc_trk_cid=121227925;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua='
            }
          >
            <img src={icon} alt="infographic statistic" />
          </Tooltip>
          <img src={spend} alt="spending habits" />
        </div>
        <div className="mobile-section" id="E">
          <h3>How do they save money?</h3>
          <p>
            <span className="green">The very concept of wealth itself is also being revolutionized. </span> Boomers matured in a world of 401k plans that matured along with them.
            Gen X entered a turbulent world and haven’t fully reckoned with the onset of their golden years. Millennials are discovering new combinations, pairing investing apps
            with traditional IRAs in a shifting world.
          </p>
        </div>

        <div className="mobile-image" id="mobile-image-save">
          <Tooltip
            position={'top'}
            y={'10%'}
            x={'30%'}
            popup={popup4}
            popupId={'popup4'}
            link={
              'https://ad.doubleclick.net/ddm/trackclk/N781268.8535CNNNETWORK/B23177801.261209447;dc_trk_aid=457310381;dc_trk_cid=121227925;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua='
            }
          >
            <img src={icon} alt="infographic statistic" />
          </Tooltip>
          <img src={save} alt="saving habits" />
        </div>
        <div className="mobile-section" id="F">
          <h3>What makes them happy?</h3>
          <p>
            <span className="green">Every generation has defined wealth in its own way—and in doing so, has reshaped the culture around them. </span>Boomers wanted to change the
            world and the world changed. Gen X entered a tumultuous economy and found they had only themselves to rely on. With their smartphones and the seemingly endless options
            that come with them, Millennials are learning how to make the new world work for them.
          </p>
        </div>
        <div className="mobile-image">
          <img src={happy} alt="what makes them happy" />
        </div>
        <h3
          className="sources-mobile"
          onClick={(e) => {
            document.querySelector('.all-images').classList.add('active');
          }}
        >
          Sources
        </h3>
        <div className="sources-image">
          <img
            className="all-images"
            src={sources}
            alt="sources"
            onClick={(e) => {
              if (e.target.classList.contains('active')) {
                e.target.classList.remove('active');
              }
            }}
          />
        </div>
        <Button
          message={'What is wealth to you?'}
          width={230}
          height={54}
          link={
            'https://ad.doubleclick.net/ddm/trackclk/N781268.8535CNNNETWORK/B23177801.261209450;dc_trk_aid=457308123;dc_trk_cid=121227925;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua='
          }
        />
      </section>
    </div>
  );
}
